import { Box, Button, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTranslation } from "../../../hooks/useTranslation";
import { GridRowSelectionModel } from "@mui/x-data-grid";
import { useState } from "react";
import { DeleteDialog } from "../../../components/form/DeleteDialog";

interface DeleteRowProps {
  endpoint: string;
  selectedItems: GridRowSelectionModel;
  resetSelection: () => void;
  disableMultiple: boolean;
}

export const DeleteRow = (props: DeleteRowProps) => {
  const { endpoint, selectedItems, resetSelection, disableMultiple } = props;
  const { translate } = useTranslation("common.components.deleteList");
  const [deleteDialog, setDeleteDialog] = useState<
    "all" | "selected" | undefined
  >();

  const firstItemId = selectedItems.length > 0 ? selectedItems[0] : "";

  return (
    <Box
      sx={{
        gap: "16px",
        display: "flex",
        alignItems: "center",
        margin: "8px 0px",
        padding: "8px 16px",
        borderRadius: "4px",
        backgroundColor: (theme) => theme.palette.customBackground.box,
      }}
    >
      <Typography>
        {translate("selected", {
          count: selectedItems?.length ?? 0,
        })}
      </Typography>
      <Button
        variant="outlined"
        color="error"
        startIcon={<DeleteIcon />}
        onClick={() => setDeleteDialog("selected")}
      >
        {translate("deleteSelected")}
      </Button>
      <Box flex={1} />
      {!disableMultiple && (
        <Button
          variant="contained"
          color="error"
          startIcon={<DeleteIcon />}
          onClick={() => setDeleteDialog("all")}
        >
          {translate("deleteAll")}
        </Button>
      )}
      <DeleteDialog
        handleClose={() => setDeleteDialog(undefined)}
        dialogType={deleteDialog}
        endpoint={disableMultiple ? endpoint + "/" + firstItemId : endpoint}
        values={disableMultiple ? {} : { ids: selectedItems }}
        resetSelection={resetSelection}
      />
    </Box>
  );
};

export default DeleteRow;
